export default {
  brand: 'CryptoPay',
  transferHint: 'Por favor, transfira para o endereço abaixo',
  rechargeAmount: 'Valor de recarga',
  rechargeAddress: 'Endereço de depósito',
  scanTip: 'Escaneie o QR code com sua carteira para pagar',
  copy: 'Copiar',
  copied: 'Copiado',
  copyFail: 'Falha ao copiar',
  networkFee: 'Taxa de rede',
  eta: 'Tempo estimado de chegada',
  etaVal: '~ 15 - 30 min',
  actualArrival: 'Você receberá',
  noticeTitle: 'Importante',
  notice1: 'Envie apenas para o endereço ou QR code exibido nesta página. Fundos enviados para endereços incorretos não podem ser recuperados.',
  notice2: 'O valor deve ser exatamente {amount} {coin}. Caso contrário, não será creditado automaticamente.',
  notice3: 'Aguarde a confirmação da blockchain (normalmente 1 confirmação).',
  notice4: 'Transações na blockchain são irreversíveis. Perdas por erro do usuário são de responsabilidade do usuário.',
  selectLang: 'Selecionar idioma',
  back: 'Voltar',
  pending: 'Pendente',
  paid: 'Pago',
  timeout: 'Expirado',
  orderNo: 'Pedido',
  loading: 'Carregando…',
  paramError: 'Parâmetros do link inválidos',
  initFail: 'Falha ao criar pedido',
  paidSuccess: 'Pagamento bem-sucedido',
  timedOut: 'Pedido expirado, tente novamente'
}